import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import api from '@/lib/api';

// Static reference chart of the studio's current commission plan. Never personal.
export const CommissionChart = () => {
  const [chart, setChart] = useState(null);
  useEffect(() => {
    api.get('/commission-chart').then(({ data }) => setChart(data)).catch(() => {});
  }, []);
  if (!chart || !chart.rows?.length) return null;
  return (
    <Card data-testid="commission-chart">
      <CardContent className="p-6">
        <h4 className="font-semibold mb-1 text-foreground">Commission chart</h4>
        <p className="text-xs text-muted-foreground mb-4">Service sales in a pay period · commission rate. A reference for everyone.</p>
        <div className="divide-y divide-border">
          {chart.rows.map((r, i) => (
            <div key={r.range} className="flex justify-between py-2 text-sm" data-testid={`commission-chart-row-${i}`}>
              <span className="text-foreground">{r.range}</span>
              <span className="font-medium text-foreground">{r.rate}</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
